import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Popup } from 'semantic-ui-react';
import _ from 'lodash';

const RETURN_KEY_CODE = 13;

export default class SearchInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  onValueChanged = (event, { value }) => {
    this.setState({
      value,
    });
  }

  onKeyDown = event => {
    const { value } = this.state;
    const { onSubmit } = this.props;
    const canInvokeCallback = _.isFunction(onSubmit);
    if (RETURN_KEY_CODE === event.which && value.length > 0 && canInvokeCallback) {
      this.props.onSubmit(value);
    }
    if (value.length === 0) {
      this.props.onSearchCleared();
    }
  }

  render() {
    const { value } = this.state;
    const { style } = this.props;
    return (
      <Popup
        trigger={
          <Input
            value={value}
            onKeyUp={this.onKeyDown}
            onChange={this.onValueChanged}
            placeholder="Search..."
            icon="search"
            style={style}
          />
        }
        content="enter your search term and hit return to search"
      />
    );
  }
}

SearchInput.propTypes = {
  onSubmit: PropTypes.func,
  onSearchCleared: PropTypes.func,
  style: PropTypes.object,
};

SearchInput.defaultProps = {
  onSubmit: _.noop,
  onSearchCleared: _.noop,
  style: null,
};



/** WEBPACK FOOTER **
 ** ./src/containers/search-input/index.js
 **/